import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select } from "ui";
import { MenuItem, Typography } from "@mui/material";
import ElavonModel from "./types/ElavonModel";
import FormRef from "../types/FormRef";

type ElavonUpdateFormProps = {
    data: ElavonModel & { accounts: any[] };
    errors: any;
    loading: boolean;
    onSubmit: (data: ElavonModel) => void;
};

const ElavonUpdateForm = forwardRef<FormRef, ElavonUpdateFormProps>(
    ({ data, errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={data}
                errors={errors}
                fields={{
                    account_id: { default: "" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Account">
                                    <Select fullWidth id="account_id">
                                        {data.accounts.map(
                                            (item: any, idx: number) => {
                                                return (
                                                    <MenuItem
                                                        value={item.id}
                                                        key={`${item.name}-${idx}`}
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection:
                                                                "column",
                                                            alignItems: "start",
                                                        }}
                                                    >
                                                        <Typography>
                                                            {item.name}
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontSize: 14,
                                                            }}
                                                        >
                                                            {item.description}
                                                        </Typography>
                                                    </MenuItem>
                                                );
                                            },
                                        )}
                                    </Select>
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default ElavonUpdateForm;
